import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type MongodbConnectorConfig = typeof MongodbConnector._.Config;

export const MongodbConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Mongodb,
  logoPath: 'images/mongodb-logo.svg',
  categories: [IntegrationConnectorCategory.Cloud],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.ServiceAccountOauth,
      configSchema: z.object({
        orgId: z
          .string()
          .regex(/^([a-f0-9]{24})$/) // this is the regex used by MongoDB to validate orgIds
          .trim()
          .min(1),
        clientId: z.string().trim().min(1),
      }),
      encryptedConfigSchema: z.object({
        clientSecret: z.string().trim().min(1),
      }),
    }),
  ]),
});
